import { saveAs } from 'file-saver';

export const formDataFromObject = (dataObj) => {
  const formData = new FormData();
  Object.entries(dataObj).forEach(([key, data]) => {
    formData.append(key, data);
  });
  return formData;
};

export function areDatesEqual(date1, date2) {
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
    throw new Error('Both arguments must be Date objects.');
  }

  const year1 = date1.getFullYear();
  const month1 = date1.getMonth();
  const day1 = date1.getDate();

  const year2 = date2.getFullYear();
  const month2 = date2.getMonth();
  const day2 = date2.getDate();

  return year1 === year2 && month1 === month2 && day1 === day2;
}

export function formatDate(date) {
  if (!date) return '';
  const options = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
}

export function increaseTime(inputDate) {
  if (!(inputDate instanceof Date)) {
    throw new Error('Invalid input. Please provide a valid Date object.');
  }
  const date = new Date(inputDate);
  const minutes = date.getMinutes();
  const hours = date.getHours();
  if (minutes > 0) {
    date.setHours(hours + 1, 0, 0, 0);
  } else {
    date.setHours(hours + 1);
  }
  return date;
}

export const parseAPKName = (value) => {
  if (typeof value === 'object') return value.name;
  if (typeof value === 'string') {
    const nameParse = value.split('/');
    return nameParse[nameParse.length - 1];
  }
};

const regex = /^(\d{2}|\d{4})[-/.](0?[1-9]|1[0-2])[-/.](0?[1-9]|[12][0-9]|3[01])$/;

export const getDayMonthYear = (newDate) => {
  if (!newDate) return '';
  if (!(newDate instanceof Date)) {
    if (newDate.match(regex)) return newDate;
  }

  const year = newDate.getFullYear();
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const day = newDate.getDate().toString().padStart(2, '0');

  return `${year}/${month}/${day}`;
};

export const downloadFile = (url) => {
  // Handle both absolute URLs (starting with //) and relative URLs (starting with /)
  let secureUrl;
  if (url.startsWith('//')) {
    secureUrl = 'https:' + url;
  } else if (url.startsWith('/')) {
    // Special handling for custom audience files
    if (url.includes('/cust_aud_files/example/')) {
      // Example files should use frontend domain
      secureUrl = window.location.origin + url;
    } else if (url.startsWith('/cust_aud_files/')) {
      // All other custom audience files should use API domain
      secureUrl = window.API_BASE_URL + url;
    } else {
      // For all other relative URLs, use the current domain
      secureUrl = window.location.origin + url;
    }
  } else {
    secureUrl = url; // Already a full URL
  }

  // For custom audience files that go through the API, skip the HEAD check
  // and directly trigger download to avoid CORS issues with S3 redirects
  if (url.startsWith('/cust_aud_files/') && !url.includes('/cust_aud_files/example/')) {
    // Use hidden anchor element to avoid opening new tab
    const link = document.createElement('a');
    link.href = secureUrl;
    link.download = secureUrl.split('/').pop();
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // Execute a HEAD request to check the file for other files
    fetch(secureUrl, { method: 'HEAD' })
      .then((response) => {
        if (response.ok) {
          // The file exists, continue downloading
          const newName = secureUrl.split('/').pop();
          saveAs(secureUrl, newName);
        } else {
          // File does not exist
          alert('File not found.');
        }
      })
      .catch(() => {
        // The request failed
        alert('An error occurred while checking the file.');
      });
  }
};

export function redirectToOldPlatformUrl(pathWithQuery) {
  // if (window.NO_REDIRECT_TO_OLD_PLATFORM) {
  //   alert('here should be redirect to old plat.');
  //   return;
  // }
  const currentUrl = new URL(window.location.href);
  const baseUrl = `https://${currentUrl.host}`;
  const newUrl = `${baseUrl}${pathWithQuery}`;
  return newUrl;
}

export const redirectToOldPlatformLoginUrl = (pathWithQuery) => {
  // if (window.NO_REDIRECT_TO_OLD_PLATFORM) {
  //   alert('here should be redirect to old plat!');
  //   return;
  // }
  const currentUrl = new URL(window.location.href);
  let domainParts = currentUrl.hostname.split('.');
  if (!isNaN(domainParts[0])) {
    domainParts.shift();
  }
  const newUrl = `https://${domainParts.join('.')}${pathWithQuery}`;
  return newUrl;
};

export const formDataToObj = (formData) => {
  const formDataObj = Array.from(formData.entries()).reduce((obj, [key, value]) => {
    if (value instanceof File) {
      obj[key] = value;
    } else if (typeof value === 'string') {
      try {
        obj[key] = JSON.parse(value);
      } catch (e) {
        obj[key] = value;
      }
    } else {
      obj[key] = null;
    }
    return obj;
  }, {});
  return formDataObj;
};
export const getIsLocalHost = () => {
  if (window.NO_REDIRECT_TO_OLD_PLATFORM) {
    return true;
  }
  const currentUrl = new URL(window.location.href);
  const isLocalHost = currentUrl.hostname.includes('localhost');
  return isLocalHost;
};

export const getCookieValue = (cookieName) => {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === cookieName) {
      return value;
    }
  }
  return null;
};

export const isPrefixInUrl = () => {
  const res = +window.location.host.split('.')[0];
  if (isNaN(res)) return false;
  if (Number.isInteger(res)) return true;
};

export const transformRememberMe = (storageValue) => {
  if (storageValue === 'true') {
    return true;
  }
  if (storageValue === 'false') {
    return false;
  }
};

export const normalizeWebsiteSearch = (value) => {
  if (typeof value !== 'string') return value;
  const cleaned = value
    .replace(/^\s+/, '')
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '');
  return cleaned.endsWith('/') && !cleaned.endsWith('//') ? cleaned.slice(0, -1) : cleaned;
};

export const redirectToLoginPage = () => {
  const prefix = +window.location.host.split('.')[0];
  alert(`redirectToLoginPage: ${prefix}`);
  if (isNaN(prefix)) {
    console.log('no prefix');
    const { origin } = window.location;
    console.log(`${origin}${window.SUB_DOMAIN}/userLogin`);
    window.location.href = `${origin}${window.SUB_DOMAIN}/userLogin`;
  }
  if (Number.isInteger(prefix)) {
    const { origin } = window.location;
    const newUrl = origin.replace(`${prefix}.`, '');
    console.log(`${newUrl}${window.SUB_DOMAIN}/adminLogin`);
    window.location.href = `${newUrl}${window.SUB_DOMAIN}/adminLogin`;
  }
};
